// Full-document render of the Oscar account-login view: PageSkeleton (the
// React document shell) wrapping the legacy account-page layout -- the brand
// heading, the LoginStandalone form island, the decorative account image, and
// the customer-service info block. The headings + decorative image arrive
// pre-localized as props (server-side gettext, matching the legacy
// {% trans %} path); the customer-service block travels as the cs_info_json
// seam. The block renders OUTSIDE the capped-width wrapper on this page (legacy
// parity; registration nests it inside).
import React from "react";
import { useStaticURL } from "tsi-common-react/src/utils/urls";

import { templates } from "@reactivated";

import { AuthCustomerServiceBlock } from "../components/AuthCustomerServiceBlock";
import { PageSkeleton } from "../components/PageSkeleton";
import { Template as LoginStandalone } from "./LoginStandaloneTemplate";

export const Template = (
    props: templates.LoginDocumentTemplate,
): React.JSX.Element => {
    const staticURL = useStaticURL();
    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            <div className="l-capped-width">
                <header>
                    <h1>{props.page_copy?.page_heading}</h1>
                </header>

                <section className="account-page-container">
                    <div>
                        <h2>{props.page_copy?.section_heading}</h2>
                        <LoginStandalone {...props.login_standalone} />
                    </div>
                    <div>
                        {props.page_copy?.account_image ? (
                            <img
                                src={`${staticURL}img/accounts/${props.page_copy.account_image}`}
                                alt={props.page_copy.account_image_alt}
                            />
                        ) : null}
                    </div>
                </section>
            </div>

            <AuthCustomerServiceBlock payload={props.cs_info_json} />
        </PageSkeleton>
    );
};
